export const lockScroll = () => {
  document.body.style.overflow = "hidden";
};

export const unlockScroll = () => {
  document.body.style.overflow = "auto";
};
